import * as am5 from '@amcharts/amcharts5';
import { isPlatformBrowser } from '@angular/common';
import {
    Inject,
    Injectable,
    NgZone,
    PLATFORM_ID
} from '@angular/core';
import { DATIQ_DEFAULT_ID } from '@dat/datiq-core/models';
import { DatiqAmcharts5RootService } from '../../../amcharts-5';
import { IDatiqGraph } from '../../../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqGraphAmChartsService {
    private _roots: { [key: string]: am5.Root };
    constructor(
        @Inject(PLATFORM_ID) private platformId,
        private zone: NgZone,
        private _root: DatiqAmcharts5RootService
    ) {
        this._roots = {};
    }

    private runAmChartsInBrowser(f: () => void): void {
        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                f();
            });
        }
    }
    init(): string {
        const rootId: string = DATIQ_DEFAULT_ID('amcharts5-root');

        return rootId;
    }

    update(rootId: string, rootElement: HTMLElement, settings: IDatiqGraph) {
        this.runAmChartsInBrowser(() => {
            this._root[rootId] = this.getCurrentRoot(
                rootId,
                rootElement,
                settings
            );
        });
    }
    getCurrentRoot(
        rootId: string,
        rootElement: HTMLElement,
        settings: IDatiqGraph
    ): any {
        return !this._roots[rootId]
            ? this._root.create(rootElement, settings)
            : this._root.update(this._roots[rootId], settings);
    }

    create(
        rootId: string,
        rootElement: HTMLElement,
        settings: IDatiqGraph
    ): void {
        this.runAmChartsInBrowser(() => {
            this._roots[rootId] = this.getRoot(rootId, rootElement, settings);
        });
    }

    getRoot(
        rootId: string,
        rootElement: HTMLElement,
        settings: IDatiqGraph
    ): am5.Root {
        return !this._roots[rootId]
            ? this._root.create(rootElement, settings)
            : this._roots[rootId];
    }

    dispose(rootId: string): void {
        this.runAmChartsInBrowser(() => {
            this._roots?.[rootId]?.dispose();
        });
    }
}
